/* eslint-disable require-unicode-regexp */
import React from 'react'
import { FC, CSSProperties } from 'react'
import { AffiliationListItem } from './AffiliationListItem'

import './AffiliationGrid.less'
import { setStyle, buildStyles } from 'shared/styleHelpers'

export interface StyleProps {
    subTitleStyle?: CSSProperties
    titleStyle?: CSSProperties
    labelStyle?: CSSProperties
    percentageStyle?: CSSProperties
}

export interface DataProps {
    affiliationSettings?: AffiliationSettingsDto
    data?: AffiliationDataRecord[]
    showSubTitle: boolean
    showTitle: boolean
    showModule: boolean
    controlId: number
}

export type AffiliationGridProps = DataProps & StyleProps

export type RenderAffiliationStylesProps = AffiliationGridProps & { affiliationSettings: AffiliationSettingsDto }

export const scopeCssToControl = (css: string) =>
    css
        // eslint-disable-next-line prefer-named-capture-group
        .replace(/([^}]+\s*){/g, ' .affiliation-container $1 {')
        .replace(/.affiliation-container\s*.affiliation-container\b/g, '.affiliation-container')

export const RenderAffiliationStyles: FC<RenderAffiliationStylesProps> = ({ ...props }) => {
    const { controlId } = props

    return (
        <>
            {props.titleStyle && setStyle(` .scoreboard-id-${controlId} h2 ${buildStyles(props.titleStyle)} `)}
            {props.subTitleStyle && setStyle(`.scoreboard-id-${controlId} h3 ${buildStyles(props.subTitleStyle)}`)}
            {props.percentageStyle && setStyle(`.scoreboard-id-${controlId} .affiliation-grid-container .grid-item-percentage ${buildStyles(props.percentageStyle)}`)}
            {props.labelStyle && setStyle(`.scoreboard-id-${controlId} .affiliation-grid-container .grid-item-label ${buildStyles(props.labelStyle)}`)}
            {
                (props.affiliationSettings.layoutSettings.overrideCssEnabled &&
                    props.affiliationSettings.layoutSettings.overrideCss) && setStyle(`
                        ${scopeCssToControl(props.affiliationSettings.layoutSettings.overrideCss).split('.affiliation-container').join(`.scoreboard-id-${controlId} .affiliation-container`)}`)
            }
        </>)
}

export const AffiliationGrid: FC<AffiliationGridProps> = props => {
    if (!props.affiliationSettings) {
        return (<div className="affiliation-container" />)
    }

    return (
        <div className="affiliation">
            <RenderAffiliationStyles {...props} affiliationSettings={props.affiliationSettings} />
            <div className={`scoreboard-id-${props.controlId}`}>
                <div className="affiliation-container">
                    {
                        props.showTitle &&
                        <h2>{props.affiliationSettings.moduleTitle}</h2>
                    }
                    {
                        props.showSubTitle &&
                        <h3>{props.affiliationSettings.moduleSubTitle}</h3>
                    }

                    {props.data && props.showModule && props.affiliationSettings &&
                        <div className="affiliation-grid-container">
                            {props.data.sort((x, y) => x.position - y.position).map(x => (
                                <AffiliationListItem key={x.affiliationName} affiliationName={x.affiliationName} imagePath={x.imagePath} label={x.label} percentage={x.percentage} imageAlternateText={x.imageAlternateText} />
                            ))}
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

AffiliationGrid.displayName = 'AffiliationGrid'
